export default [
  {
    path: "roles",
    name: "roles",
    component: (): Promise<any> => import(/* webpackChunkName: "roles" */ "@/views/Admin/RolesView.vue")
  }
];
